// extracted by mini-css-extract-plugin
export default {"spinner-content":"IpaAdministrationWizard_spinner-content__xnwoR","spinner":"IpaAdministrationWizard_spinner__6Bh5S"};